/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmComplianceType from '@jira/spa-apps__admin-pages-products-jsm-compliance/src/ProductsJsmComplianceType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmCompliance: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJsmComplianceType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-compliance", jiraSpaEntry: "async-products-jsm-compliance" */ '@jira/spa-apps__admin-pages-products-jsm-compliance/src/ProductsJsmComplianceType.tsx'
		),
	),
);

const AsyncProductsJsmCompliance = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmCompliance}
		pageId="products-jsm-compliance"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmCompliance;
